export const validation = {
  client: {
    emails: {
      eachTypeSelected: 'Duid minstens één e-mailadres aan voor elk type e-mail',
      noEmptySelection: 'Selecteer minstens één type e-mail per e-mailadres',
    },
  },
  dateFuture: 'Kies een datum in de toekomst.',
  dateSameOrAfter: '{{attribute}} moet op of na de {{after}} zijn.',
  dateTomorrow: 'De vervaldatum moet minstens morgen zijn.',
  email: {
    invalid: 'Vul een geldig e-mailadres in.',
  },
  iban: 'Vul een geldig rekeningnummer in.',
  integrations: {
    accountantEmailInvalid: 'Je boekhouder heeft nog geen account op ons Credit-platform.',
  },
  invoice: {
    lines: {
      minimumOne: 'Voeg minstens één factuurlijn toe aan de factuur.',
      minimumOneNotFree: 'Voeg minstens één factuurlijn toe die niet gratis is.',
    },
  },
  invoiceTemplate: {
    nextInvoiceTomorrow: 'Je volgende factuur kan ten vroegste morgen zijn.',
  },
  max: '{{attribute}} mag niet groter zijn dan {{max}}.',
  maxDiscount: 'De korting mag niet groter zijn dan de totale prijs.',
  maxFileSize: 'Het bestand mag niet groter zijn dan {{max}} MB.',
  maxLength: '{{attribute}} mag niet langer zijn dan {{max}} karakters.',
  maxLengthInLanguage: '{{attribute}} mag niet langer zijn dan {{max}} karakters ({{lang}}).',
  min: '{{attribute}} mag niet kleiner zijn dan {{min}}.',
  minLength: '{{attribute}} moet langer zijn dan {{min}} karakters.',
  password: {
    incorrect: 'Incorrect wachtwoord',
    match: 'Dit wachtwoord moet exact hetzelfde zijn als het nieuwe wachtwoord.',
  },
  phoneNumber: {
    format: 'Vul een geldig telefoonnummer in.',
    missingCallingCode: 'Het telefoonnummer moet starten met een landcode, +32 in België bijvoorbeeld.',
  },
  quotation: {
    lines: {
      minimumOne: 'Voeg minstens één offertelijn toe aan de offerte.',
      minimumOneNotFree: 'Voeg minstens één offertelijn toe die niet gratis is.',
    },
  },
  required: 'Dit veld is verplicht.',
  requiredAttribute: '{{attribute}} is verplicht.',
  requiredInLanguage: 'Dit veld is verplicht ({{lang}}).',
  vatNumber: {
    belgianFormat: 'Geef je een geldig ondernemingsnummer in? Dat bestaat uit 10 cijfers en start met 0 of 1.',
    inactive: 'Deze organisatie is niet actief.',
    invalid: 'Het btw-nummer is ongeldig, vraag je het nog eens op?',
    unique:
      'Je hebt al een klant aangemaakt met dit btw-nummer. <0>Klik hier</0> om een nieuwe contactpersoon toe te voegen aan deze klant.',
  },
};
